module.exports = __webpack_public_path__ + "static/media/Gratitude.adeba62f.jpg";